import { Injectable } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache = new Map<string, any>();
 
  setCache(key: string, data: any): void {
    this.cache.set(key, data);
  }
 
  getCache(key: string): any | null {
    return this.cache.get(key) || null;
  }
 
  clearCache(key: string): void {
    this.cache.delete(key);
  }
}